import { Calculator, Handshake, Users, Megaphone, Sparkles, Headphones, MessagesSquare, KanbanSquare, ShoppingCart, ShieldCheck, LayoutGrid, BarChart3, Cloud, Code2, Briefcase, Globe } from "lucide-react";

export const ICONS = { Calculator, Handshake, Users, Megaphone, Sparkles, Headphones, MessagesSquare, KanbanSquare, ShoppingCart, ShieldCheck, LayoutGrid, BarChart3, Cloud, Code2, Briefcase, Globe };

export default function CategoryIcon({ name, className = "h-5 w-5" }) {
  const Icon = ICONS[name] || LayoutGrid;
  return <Icon className={className} aria-hidden="true" />;
}
